import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { colorBlack, colorRed } from 'resources/styles/Colors';
import { Bookmark, TouchableOpacity } from 'components/utility/Buttons';
import { XStack, SizableText, Stack } from 'tamagui';
import { createParam } from 'solito';
import {
  InvertColorsIcon,
  ProgressFullIcon,
} from 'app/components/utility/SVGIcons';
import { useSettings } from 'contexts/SettingsContext';
import {
  useCreateOrUpdateBookmarkMutation,
  useDeleteBookmarkMutation,
  useGetBookmarksByUserQuery,
} from 'utils/RTKGraphQL';
import { toggleLogin } from 'reducers/slices/loginstatus';

const ArticleControls = React.memo((props) => {
  const [createOrUpdateBookmark] = useCreateOrUpdateBookmarkMutation();
  const [deleteBookmark] = useDeleteBookmarkMutation();
  const { settings, updateSetting } = useSettings();
  const profile = useSelector((state) => state.profile);
  const dispatch = useDispatch();
  const { useParam } = createParam();
  const [slug] = useParam('slug');

  const collectionId = props.article.collections[0]?.id;

  const { data: bookmarks } = useGetBookmarksByUserQuery(profile?.id, {
    skip: !profile?.id,
  });

  const isBookmarked = bookmarks?.some(
    (bookmark) => bookmark.collection?.id === collectionId
  );

  const [localBookmark, setLocalBookmark] = useState(isBookmarked);

  const _bookmarkToggle = useCallback(async () => {
    if (!profile) {
      dispatch(toggleLogin(true));
      return;
    }

    if (localBookmark) {
      await deleteBookmark({
        userId: profile.id,
        collectionId: collectionId,
      });
    } else {
      await createOrUpdateBookmark({
        userId: profile.id,
        collectionId: collectionId,
      });
    }
    setLocalBookmark((prev) => !prev);
  }, [
    profile,
    localBookmark,
    deleteBookmark,
    createOrUpdateBookmark,
    collectionId,
    dispatch,
  ]);

  const toggleSetting = useCallback(
    (key) => {
      updateSetting(key, !settings[key]);
    },
    [updateSetting, settings]
  );

  useEffect(() => {
    setLocalBookmark(isBookmarked);
  }, [isBookmarked]);

  return (
    <XStack
      justifyContent="space-around"
      flex={1}
      alignItems="center"
      zIndex={999}
    >
      <TouchableOpacity onPress={() => toggleSetting('charColors')}>
        <InvertColorsIcon
          size={25}
          color={settings.charColors ? colorRed : colorBlack}
          style={[{ fontSize: 25 }]}
        />
      </TouchableOpacity>
      <TouchableOpacity onPress={() => toggleSetting('pinyinColors')}>
        <SizableText
          fontSize="$lg"
          color={settings.pinyinColors ? colorRed : colorBlack}
        >
          颜
        </SizableText>
      </TouchableOpacity>
      {props.article?.collections[0]?.articleCount < 2 ? (
        <Bookmark
          onPress={_bookmarkToggle}
          saved={localBookmark}
          size={50}
          color="#c9150f"
        />
      ) : (
        <Stack height={50} />
      )}
      <TouchableOpacity onPress={() => toggleSetting('traditional')}>
        <SizableText
          fontSize="$lg"
          color={settings.traditional ? colorRed : colorBlack}
        >
          体
        </SizableText>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => toggleSetting('showPinyin')}>
        <ProgressFullIcon
          size={25}
          color={settings.showPinyin ? colorRed : colorBlack}
          style={[{ fontSize: 25 }]}
        />
      </TouchableOpacity>
    </XStack>
  );
});

export default ArticleControls;
